<template>
  <fade-transition>
    <div
      v-show="popUpActive"
      class="popup-dialog"
      :class="{ active: popUpActive, bottom: bottom && !isLoading, unbottom: unbottom }"
    >
      <perfect-scrollbar
        ref="perfectScrollbar"
        v-scroll:throttle="{ fn: $_onScroll, throttle: 32 }"
        class="scroll-content"
        :class="{ 'overflow-visible': overflowVisible }"
      >
        <div
          ref="scrollableContentWidth"
          class="scrollable-popup-container"
          :class="{ 'center-columm': isCenterColumn }"
          :style="_scrollableContainerStyle"
        >
          <DotLoading v-if="isLoading" />
          <div v-else>
            <i v-if="!noCloseIcon" class="icon-close close-btn" @click="$_popUpClose('icon')" />
            <div v-if="title" class="popup_title">
              <div class="popup_title__button">
                <slot name="title-button" />
              </div>
              <p class="popup_title__text">{{ $t(title) }}</p>
            </div>
            <slot :position="position" />
            <ScrollFixedBottomBar
              v-if="bottom"
              ref="ScrollFixedBottomBar"
              :autoHeight="autoHeight"
              :step-btn="isStepBtn"
              :bottom-bar-width="bottomBarWidth"
              :bottom-bar-left-position="bottomBarLeftPosition"
              :scroll="position.scrollTop"
              :hasMoreContent="hasMoreContent"
              @height-changed="$_onBottomBarHeightChanged"
            >
              <template slot="bottomBtn">
                <slot name="bottomBtn" />
              </template>
            </ScrollFixedBottomBar>
          </div>
        </div>
        <div class="popup-bg" :class="{ active: popUpActive }" @click="$_popUpClose('outside')" />
      </perfect-scrollbar>
      <div v-if="popUpActive && nav" class="nav-bar">
        <div class="nav-btn" @click="$_preClick()">
          <i class="icon-chevron-back" />
        </div>
        <div class="nav-btn" @click="$_nextClick()">
          <i class="icon-chevron-forward" />
        </div>
      </div>
    </div>
  </fade-transition>
</template>
<script>
export default {
  name: 'Popup',
  props: {
    popUpActive: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    unbottom: {
      type: Boolean,
      default: false,
    },
    nav: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    notice: {
      type: Boolean,
      default: false,
    },
    isCenterColumn: {
      type: Boolean,
      default: false,
    },
    isStepBtn: {
      type: Boolean,
      default: false,
    },
    overflowVisible: {
      type: Boolean,
      default: false,
    },
    noCloseIcon: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    hasMoreContent: {
      type: Boolean,
      default: false,
    },
    clickOutsideClose: {
      type: Boolean,
      default: true,
    },
    autoHeight: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    window: {
      width: 0,
      height: 0,
    },
    bottomBarWidth: 0,
    bottomBarLeftPosition: 0,
    position: { scrollTop: 0, scrollLeft: 0 },
    popupHeight: 0,
    height: null,
    bottomBarHeight: 0,
  }),
  computed: {
    _scrollableContainerStyle() {
      const base = { width: this.width };
      if (this.autoHeight && this.bottom && this.bottomBarHeight > 0) {
        base.paddingBottom = `${this.bottomBarHeight + 24}px`;
      }
      return base;
    },
  },
  watch: {
    position: {
      deep: true,
      handler() {
        this.$_getBottomBarWidth();
      },
    },
    popUpActive() {
      if (this.bottom && this.popUpActive) {
        this.$nextTick(() => {
          this.$_getBottomBarWidth();
        });
      }
    },
    height() {
      if (this.$refs.ScrollFixedBottomBar) {
        this.$refs.ScrollFixedBottomBar.$_getBottomBarHeight();
        this.$refs.ScrollFixedBottomBar.$_bottomBarHide();
      }
    },
  },
  mounted() {
    this.$_handleResize();
    this.$_getBottomBarWidth();
    this.$_updateDivHeight();
  },
  created() {
    window.addEventListener('resize', this.$_handleResize);
    window.addEventListener('resize', this.$_getBottomBarWidth);
  },
  updated() {
    this.$_updateDivHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_handleResize);
    window.removeEventListener('resize', this.$_getBottomBarWidth);
  },
  methods: {
    $_handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.notice) return;
    },
    $_getBottomBarWidth() {
      if (!this.$refs.scrollableContentWidth) {
        return null;
      }
      let contnetWidth = this.$refs.scrollableContentWidth.getBoundingClientRect();
      this.bottomBarWidth = contnetWidth.width;
      this.bottomBarLeftPosition = contnetWidth.x;
      this.popupHeight = contnetWidth.height;
    },
    $_onScroll(e, position) {
      this.position = position;
      this.position.scrollTotalHeight = e.target.scrollHeight;
      this.position.windowTotalHeight = e.target.offsetHeight;
      this.$emit('scroll', this.position);
    },
    $_popUpClose(type) {
      if (type === 'outside' && !this.clickOutsideClose) return;
      this.$emit('click');
      if (this.bottom) {
        this.$_getBottomBarWidth();
      }
    },
    $_nextClick() {
      this.$emit('next-click');
    },
    $_preClick() {
      this.$emit('pre-click');
    },
    $_updateDivHeight() {
      this.$nextTick(() => {
        if (!this.$refs.scrollableContentWidth) return;
        this.height = this.$refs.scrollableContentWidth.offsetHeight;
      });
    },
    $_onBottomBarHeightChanged(height) {
      this.bottomBarHeight = height;
    },
    $_getScrollEl() {
      return this.$refs.perfectScrollbar ? this.$refs.perfectScrollbar.$el : null;
    },
    $_scrollTo(top) {
      const el = this.$_getScrollEl();
      if (!el) return;
      el.scrollTop = top;
      if (this.$refs.perfectScrollbar && this.$refs.perfectScrollbar.ps) {
        this.$refs.perfectScrollbar.ps.update();
      }
    },
    $_scrollBy(delta) {
      const el = this.$_getScrollEl();
      if (!el) return false;
      if (this.$refs.perfectScrollbar && this.$refs.perfectScrollbar.ps) {
        this.$refs.perfectScrollbar.ps.update();
      }
      const maxScroll = el.scrollHeight - el.clientHeight;
      if (maxScroll <= 0) return false;
      const next = Math.max(0, Math.min(maxScroll, el.scrollTop + delta));
      if (next === el.scrollTop) return false;
      el.scrollTop = next;
      if (this.$refs.perfectScrollbar && this.$refs.perfectScrollbar.ps) {
        this.$refs.perfectScrollbar.ps.update();
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/popup';
</style>
